import styled from "styled-components";
import pencilPng from "../images/pencil.png";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
`;

export const Canvas = styled.div`
  width: 100%;
  height: 100%;
  cursor: url("${pencilPng}") 0 16, auto;

  svg {
    width: 100%;
    height: 100%;
  }
`;
